// «Aspettano te»: le sessioni ferme su una domanda, con cosa chiedono e da quanto.
import { Link } from 'react-router-dom';
import { Pop } from '../../../components/Pop';
import { RelativeTime } from '../../../components/RelativeTime';
import type { PendingPromptData, Session } from '../../../types';
import { Widget } from '../Widget';

// chi chiede: il PM per piani e domande, il Team Leader per i chiarimenti, il DevOps per le quote
const KIND: Record<PendingPromptData['kind'], { label: string; pop: string; tint: string }> = {
  rendezvous: { label: 'Da approvare', pop: 'project-manager-01', tint: 'lilac' },
  clarification: { label: 'Chiarimento', pop: 'team-lead-01', tint: 'blue' },
  question: { label: 'Domanda', pop: 'project-manager-01', tint: 'lilac' },
  quota: { label: 'Quota esaurita', pop: 'devops-01', tint: 'coral' },
};

export function Waiting({ sessions }: { sessions: Session[] }) {
  return (
    <Widget title="Aspettano te" icon="hand" tint="pink" count={sessions.length}>
      {sessions.length === 0 ? (
        <div className="t-caption faint">Nessuno ti aspetta: nessuna domanda aperta.</div>
      ) : (
        <div style={{ display: 'grid', gap: 12 }}>
          {sessions.map((s) => {
            const k = KIND[s.pending?.kind ?? 'question'];
            return (
              <Link key={s.id} to={`/s/${s.id}`} className="dash-ask">
                <span className="dash-face" data-tint={k.tint}>
                  <Pop avatar={k.pop} size={54} />
                </span>
                <span style={{ flex: 1, minWidth: 0, display: 'grid', gap: 6 }}>
                  <span className="t-caption faint trunc">
                    {k.label} · {s.title}
                    {s.projectName ? ` · ${s.projectName}` : ''} ·{' '}
                    <RelativeTime at={s.pending?.since ?? s.updatedAt} />
                  </span>
                  <span className="dash-ask-question">{s.pending?.question ?? ''}</span>
                  <span>
                    <span className="dash-action">Rispondi</span>
                  </span>
                </span>
              </Link>
            );
          })}
        </div>
      )}
    </Widget>
  );
}
